import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

interface NotificationIndicatorProps {
  isConnected: boolean;
}

const NotificationIndicator: React.FC<NotificationIndicatorProps> = ({ isConnected }) => {
  return (
    <div className="fixed bottom-4 right-4 flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-lg border">
      {isConnected ? (
        <>
          <Wifi size={18} className="text-green-500" />
          <span className="text-sm font-medium text-green-700">Live Updates Active</span>
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        </>
      ) : (
        <>
          <WifiOff size={18} className="text-gray-400" />
          <span className="text-sm font-medium text-gray-500">Disconnected</span>
        </>
      )}
    </div>
  );
};

export default NotificationIndicator;
